import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Data = {
	petitionId: string;
	status: string;
	discoverable: string;
	promotable: string;
	starterId: string;
	urls: {
		petitionAdmin: string;
		editTags: string;
		promotionSettings: string;
		victory: string;
		userAdmin: string;
		dashboard: string;
		edit: string;
		movementAdmin: string | undefined;
	};
};

type Result = ModelHookResult<Data>;

const yesNo = (value: boolean) => (value ? 'Yes' : 'No');

export function usePetitionStaffDrawer(): Result {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const { id, slug, status, discoverable, promotable, user, movementsConnection } = petition;
	const movementId = movementsConnection.nodes[0]?.id;

	const urls = useMemo(() => {
		const encodedSlug = encodeURIComponent(slug);
		return {
			petitionAdmin: `/admin/p/${encodedSlug}`,
			editTags: `/admin/p/${encodedSlug}/edit_tags`,
			promotionSettings: `/admin/promotion_settings/petitions/${id}`,
			victory: `/admin/p/${id}/victory`,
			userAdmin: `/admin/u/${user.id}`,
			dashboard: `/p/${encodedSlug}/dashboard`,
			edit: `/p/${encodedSlug}/edit`,
			movementAdmin: movementId ? `/admin/m/${movementId}` : undefined,
		};
	}, [id, slug, user.id, movementId]);

	return {
		data: {
			petitionId: id,
			status,
			discoverable: yesNo(discoverable),
			promotable: yesNo(promotable),
			starterId: user.id,
			urls,
		},
	};
}
